var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmericanSamoa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.196 32.112C343.412 11.664 301.07 0 256 0C114.626 0 0.018 114.598 0 255.97L178.087 166.957L380.196 32.112Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 256.03C0.018 397.402 114.626 512 256 512C301.07 512 343.412 500.338 380.196 479.888L178.087 345.043L0 256.03Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.53 45.3822C394.654 40.6232 387.529 36.1972 380.187 32.1162L0 255.97V256C0 256 0 256.021 0 256.03L380.188 479.883C387.53 475.801 394.654 471.376 401.531 466.617L43.822 256L401.53 45.3822Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.217 246.453H414.723C422.652 236.933 422.163 222.77 413.23 213.839C422.692 204.378 422.692 189.037 413.23 179.574L412.66 180.146C422.121 170.685 422.692 154.772 413.23 145.311L276.174 282.367C285.636 291.83 300.708 291.717 310.169 282.255L312.807 279.844L378.435 273.878V302.104H400.696V271.854L434.087 268.819L445.217 246.453Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.269 311.652L256 300.522L278.269 289.391H422.964V311.652H278.269Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanSamoa);
export default __webpack_public_path__ + "static/media/americanSamoa.27e34326614724065ed26565ebfdded6.svg";
export { ForwardRef as ReactComponent };